import axios from "axios"

const state = {
    filters: {
        account: null,
        month: new Date().toISOString().substr(0, 7),
    },
    userImages: {
        images: [],
        isLoading: false,
    },
    userPaysheets: {
        paysheets: [],
        isLoading: false,
        isOpen: false
    },
    userContracts: {
        dateFilter: null,
        contracts: [],
        isLoading: false,
        isOpen: false
    },
    paths: {
        userImageUploadPath: '/api/storage/user-images/',
        userPaysheetUploadPath: '/api/storage/user-paysheets/',
        userContractsUploadPath: '/api/storage/user-contracts/',
    }
}

const mutations = {
    accountFilter(state, account) {
        state.filters.account = account
    },
    monthFilter(state, month) {
        state.filters.month = month
    },
    userImages(state, userImages) {
        state.userImages.images = userImages
    },
    userImagesIsLoading(state, isLoading) {
        state.userImages.isLoading = isLoading
    },
    userPaysheets(state, userPaysheets) {
        state.userPaysheets.paysheets = userPaysheets
    },
    userPaysheetsIsLoading(state, isLoading) {
        state.userPaysheets.isLoading = isLoading
    },
    userPaysheetsIsOpen(state, isOpen) {
        state.userPaysheets.isOpen = isOpen
    },
    userContracts(state, userContracts) {
        state.userContracts.contracts = userContracts
    },
    userContractsIsLoading(state, isLoading) {
        state.userContracts.isLoading = isLoading
    },
    userContractsIsOpen(state, isOpen) {
        state.userContracts.isOpen = isOpen
    }
}

const actions = {
    async uploadUserImages({ state, getters, dispatch, commit }, {signature, dni_front, dni_back, account}) {
        commit('userImagesIsLoading', true)
        try {
            let formData = new FormData()
            account = account ?? JSON.parse(localStorage.getItem('cuenta')).id
            formData.append('account', account)

            if (signature) {
                formData.append('signature', signature)
            }
            if (dni_front) {
                formData.append('dni_front', dni_front)
            }
            if (dni_back) {
                formData.append('dni_back', dni_back)
            }

            await axios.post(`${getters.getEndpointFromPath(state.paths.userImageUploadPath)}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Imagen de Firma Actualizada!",
            }, { root: true })

        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Actualizar la Imagen de Firma',
            }, { root: true })
        }
        dispatch('getUserImages')
        commit('userImagesIsLoading', false)
    },
    async deleteUserImagesPartial({ state, getters, dispatch, commit }, {field, id}) {
        commit('userImagesIsLoading', true)
        try {
            let params = {
                field: field
            }
            await axios.delete(`${getters.getEndpointFromPath(state.paths.userImageUploadPath)}${id}`, {
                params: params
            })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Imagen de Firma Actualizada!",
            }, { root: true })
        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Actualizar la Imagen de Firma',
            }, { root: true })
        }
        dispatch('getUserImages')
        commit('userImagesIsLoading', false)
    },
    async getUserImages({ state, getters, dispatch, commit, rootGetters }) {
        commit('userImagesIsLoading', true)
        try {
            const hasAdminPermission = rootGetters['login/hasAdminPermission'] || rootGetters['login/hasSuperAdminPermission'];
            const account = state.filters.account || !hasAdminPermission ? getters.getAccountParam(state.filters.account) : null;
            const response = await axios.get(`${getters.getEndpointFromPath(state.paths.userImageUploadPath)}`, {
                params: {
                    account: account,
                }
            })
            commit('userImages', response.data)
        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Obtener las Imagenes del Usuario',
            }, { root: true })
        }
        commit('userImagesIsLoading', false)
    },
    async uploadUserPaysheet({ state, getters, dispatch, commit }, {account, paysheet, month}) {
        commit('userPaysheetsIsLoading', true)
        try {
            if (month.length === 7) {
                month = month + '-01'
            }

            let formData = new FormData()
            formData.append('account', account)
            formData.append('month', month)
            formData.append('paysheet', paysheet)

            await axios.post(`${getters.getEndpointFromPath(state.paths.userPaysheetUploadPath)}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Comprobante de Pago Actualizado!",
            }, { root: true })

        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Actualizar el Comprobante de Pago',
            }, { root: true })
        }
        dispatch('getUserPaysheet')
        commit('userPaysheetsIsLoading', false)
    },
    async getUserPaysheet({ state, getters, dispatch, commit, rootGetters }) {
        commit('userPaysheetsIsLoading', true)
        try {
            const getDate = () => {
                if (state.filters.month) {
                    let firstDay = new Date(state.filters.month)
                    firstDay.setDate(1)
                    let lastDay = new Date(state.filters.month)
                    lastDay.setMonth(lastDay.getMonth() + 1)
                    lastDay.setDate(0)

                    return [firstDay.toISOString().substr(0, 10), lastDay.toISOString().substr(0, 10)]
                }
                return null
            }

            const hasAdminPermission = rootGetters['login/hasAdminPermission'] || rootGetters['login/hasSuperAdminPermission'];
            const account = state.filters.account || !hasAdminPermission ? getters.getAccountParam(state.filters.account) : null;
            const response = await axios.get(`${getters.getEndpointFromPath(state.paths.userPaysheetUploadPath)}`, {
                params: {
                    account: account,
                    month: getDate()
                }
            })
            commit('userPaysheets', response.data)
        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Obtener el Comprobante de Pago',
            }, { root: true })
        }
        commit('userPaysheetsIsLoading', false)
    },
    async deleteUserPaysheet({ state, getters, dispatch, commit }, id) {
        commit('userPaysheetsIsLoading', true)
        try {
            await axios.delete(`${getters.getEndpointFromPath(state.paths.userPaysheetUploadPath)}${id}`)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Comprobante de Pago Eliminado!",
            }, { root: true })

        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Eliminar el Comprobante de Pago',
            }, { root: true })
        }
        dispatch('getUserPaysheet')
        commit('userPaysheetsIsLoading', false)
    },
    async uploadUserContract({ state, getters, dispatch, commit }, {contract, contract_name, contract_type, account}) {
        commit('userContractsIsLoading', true)
        try {
            let formData = new FormData()
            account = account ?? JSON.parse(localStorage.getItem('cuenta')).id
            formData.append('account', account)
            
            if (contract) {
                formData.append('contract', contract)
            }
            if (contract_name) {
                formData.append('contract_name', contract_name)
            }

            if(contract_type) {
                formData.append('contract_type', contract_type)
            }

            await axios.post(`${getters.getEndpointFromPath(state.paths.userContractsUploadPath)}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Contrato Actualizado!",
            }, { root: true })

        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Actualizar el Contrato',
            }, { root: true })
        }
        dispatch('getUserContracts')
        commit('userContractsIsLoading', false)
    },
    async getUserContracts({ state, getters, dispatch, commit, rootGetters }) {
        commit('userContractsIsLoading', true)
        try {
            const hasAdminPermission = rootGetters['login/hasAdminPermission'] || rootGetters['login/hasSuperAdminPermission'];
            const account = state.filters.account || !hasAdminPermission ? getters.getAccountParam(state.filters.account) : null;
            const response = await axios.get(`${getters.getEndpointFromPath(state.paths.userContractsUploadPath)}`, {
                params: {
                    account: account,
                }
            })
            commit('userContracts', response.data)
        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Obtener los Contratos',
            }, { root: true })
        }
        commit('userContractsIsLoading', false)
    },
    async deleteUserContract({ state, getters, dispatch, commit }, id) {
        commit('userContractsIsLoading', true)
        try {
            await axios.delete(`${getters.getEndpointFromPath(state.paths.userContractsUploadPath)}${id}`)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Contrato Eliminado!",
            }, { root: true })

        } catch (error) {
            console.log(error)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Eliminar el Contrato',
            }, { root: true })
        }
        dispatch('getUserContracts')
        commit('userContractsIsLoading', false)
    },
    async fetchAll({ getters, dispatch }) {
        let account = getters.getAccountParam()

        dispatch('getUserImages')
        dispatch('getUserPaysheet')
        dispatch('getUserContracts')
    }
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    getAccountParam: (_state, _unused, rootState, rootGetters) => account => {        
        if (account) {
            return typeof(account) === 'object' ? account.id : account
        } else if (rootGetters['login/hasAdminPermission'] && _state.filters.account) {
            return _state.filters.account
        } else {
            return JSON.parse(localStorage.getItem('cuenta'))?.id
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}